export function createLogLineWorker(): Worker {
  return new Worker(new URL('./log-line-worker', import.meta.url), {
    type: 'module',
  });
}
